import { css } from '@repo/pandacss/styled-system/css';

export const triggerStyles = css({
  textStyle: 'textTiny',
  color: 'blue.main',
  backgroundColor: 'transparent',
  borderTopWidth: 'none',
  borderRightWidth: 'none',
  borderBottomWidth: 'none',
  borderLeftWidth: 'none',
  borderTopStyle: 'none',
  borderRightStyle: 'none',
  borderBottomStyle: 'none',
  borderLeftStyle: 'none',
  cursor: 'pointer',
  paddingTop: '0',
  paddingRight: '0',
  paddingBottom: '0',
  paddingLeft: '0',
  textAlign: 'left',
  _hover: {
    textDecorationLine: 'underline',
  },
});
